import { isEmpty, isEqual, isNil } from 'lodash';
import { FileUpload } from '@shared/types/fieldValues';
import { EditableField, Field } from './Field';

export class AuditTagField implements EditableField {
  readonly fieldType = 'AuditTagField';
  readonly tags: string[];
  readonly files: FileUpload[];
  readonly notes: string;

  constructor({ tags, files, notes }: { tags: string[]; files: FileUpload[]; notes: string }) {
    this.tags = tags;
    this.files = files;
    this.notes = notes;
  }

  validate(): string | null {
    return null;
  }

  isEqual(field: Field): boolean {
    return (
      field instanceof AuditTagField &&
      isEqual(this.tags, field.tags) &&
      isEqual(this.files, field.files) &&
      this.notes === field.notes
    );
  }

  toFieldJson() {
    return { tags: this.tags, files: this.files, notes: this.notes };
  }

  toDisplayString(): string {
    return this.tags.join(', ');
  }

  get isEmpty() {
    return isEmpty(this.tags);
  }

  get hasData() {
    return !this.isEmpty || !isEmpty(this.files) || !isEmpty(this.notes.trim());
  }

  static fromFieldJson(json: any): AuditTagField | null {
    if (isNil(json) || typeof json !== 'object') {
      return null;
    }
    return new AuditTagField({
      tags: Array.isArray(json.tags) ? json.tags : [],
      files: Array.isArray(json.files) ? json.files : [],
      notes: typeof json.notes === 'string' ? json.notes : '',
    });
  }
}
